import { Whatsapp } from "@/api/api";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";

const WhatsapPhoneBtn = ({ ssr, RoutingTypeId }) => {
  const [data, setData] = useState(null);
  const [text, setText] = useState("");

  useEffect(() => {
    Whatsapp().then((e) => {
      setData(e.data); // API'den gelen veriyi kaydet
    });
  }, []);

  useEffect(() => {
    if (RoutingTypeId === "Detail" && ssr?.baslik) {
      setText(`Merhaba, ${ssr.baslik} hakkında bilgi almak istiyorum.`);
    } else {
      setText("");
    }
  }, [RoutingTypeId, ssr]);

  if (!data) {
    return (
      <>
        <div
          id="whatsapp_click"
          className="flex flex-col items-center justify-center text-center"
        >
          <Image
            src="/whatsappBottom.svg"
            width={30}
            height={30}
            alt="whatsapp"
            className="object-contain"
          />
          <span className="text-[0.625rem] font-medium leading-3">
            WhatsApp
          </span>
        </div>
        <div
          id="phone_click"
          className="flex flex-col items-center justify-center text-center"
        >
          <Image
            src="/call.svg"
            width={30}
            height={30}
            alt="whatsapp"
            className="object-contain"
          />
          <span className="text-[0.625rem] font-medium leading-3">Telefon</span>
        </div>
      </>
    );
  }

  return (
    <>
      <Link
        href={`https://wa.me/${data.telefon}?text=${encodeURIComponent(text)}`}
        target="_blank"
        prefetch={false}
      >
        <div className="flex flex-col items-center justify-center text-center h-full gap-y-1">
          <Image
            src="/whatsappBottom.svg"
            width={30}
            height={30}
            alt="whatsapp"
            className="object-contain"
          />
          <span className="text-[0.625rem] font-medium leading-3">WhatsApp</span>
        </div>
      </Link>
      <Link href={`tel:${data.telefon}`}>
        <div className="flex flex-col items-center justify-center text-center h-full gap-y-1">
          <Image
            src="/call.svg"
            width={30}
            height={30}
            alt="whatsapp"
            className="object-contain"
          />
          <span className="text-[0.625rem] font-medium leading-3">Telefon</span>
        </div>
      </Link>
    </>
  );
};

export default WhatsapPhoneBtn;
